import { api } from "@/redux/api";

/**
 * List-run endpoints, injected separately so they do not grow `list.api.ts` — that file sits at the
 * architecture gate's length ceiling.
 */
export const listProcessingApi = api.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Picks a finished list back up so a newly delivered file gets processed (PREC-3091).
		 * A scraping list is ONCE: once it completes, nothing starts it again on its own.
		 */
		restartListProcessing: builder.mutation<{ success: boolean }, number>({
			query: (id) => ({
				url: `list/${id}/restart-processing`,
				method: "POST",
			}),
			invalidatesTags: (result, error, id) => [{ type: "List" as const, id }, "List" as const],
		}),
	}),
});

export const { useRestartListProcessingMutation } = listProcessingApi;
